import axios from "axios";
import { ticketBaseURL } from "../configs/api";

export const post_RdRentalAchInfo = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalACHInfo?userId=${userId}`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_RdRentalAchInfo = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalACHInfo?userId=${userId}`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const delete_RdRentalAchInfo = async (primaryKey: number, userId: string) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalACHInfo`,
        method: "DELETE",
        params: { id: primaryKey, userId: userId }
    });
    return response.data;
}

export const getRdRentalACHInfoWithTenantIdAndIsActive = (tenantId: string) => {
    return getFetch(`rdRentalACHInfo/GetRdRentalACHInfoByTenantIdAndIsActive/${tenantId}`)
}

export const getRdRentalACHInfoWithTenantId = (tenantId: string, page: number, size: number) => {
    return getFetch(`rdRentalACHInfo/GetRdRentalACHInfosPagingByTenantId/${tenantId},${page},${size}`)
}

const getFetch = async (url: string, params = {}) => {
    const response = await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    });
    return response.data;
}